import { ReactNode } from "react";

import { IChartSeries } from "store/views/reports";
import { capitalizeFirstLetter } from "utils/string";

import { IExtendedColumn } from "./interfaces";
import { getColumnEvenOddClassName } from "./utils";

/**
 * Prepare common columns that should be fixed on the left side
 * @param series from chart options
 */
export function getFixedColumns(series: IChartSeries[], header?: ReactNode): IExtendedColumn[] {
  const longestSeriesName = Math.max(...series.map((singleSeries: IChartSeries) => singleSeries.name?.length ?? 0), 15);

  const doesEverySeriesHaveCustomElement = series.every(
    (singleSeries: IChartSeries) => singleSeries.extras?.breakdownCustomElement
  );

  const columns: IExtendedColumn[] = [];

  const className = getColumnEvenOddClassName(columns.length);
  columns.push({
    Header: header ?? "Series",
    accessor: doesEverySeriesHaveCustomElement ? "breakdownCustomElement" : "name",
    fixed: "left",
    className,
    headerClassName: className,
    width: longestSeriesName * 9,
    Cell: ({ value }) => (doesEverySeriesHaveCustomElement && value ? value : capitalizeFirstLetter(value)),
  });

  return columns;
}
